export default __webpack_public_path__ + "static/media/notGreat.54aeecdc.svg";